import { http } from "@/http";

export default {
  namespaced: true,

  state: {

  },

  getters: {

  },

  mutations: {
    setState(state, { items, propertyName }) {
      state[propertyName] = items;
    },

  },
  actions: {
    async apiGet({ commit }, { apiRelativePath, propertyName }) {
      const response = await http.get(apiRelativePath)
        .then(response => {
          if(response.status === 200) {
            commit('setState', { items: response.data, propertyName });
            return Promise.resolve(response);
          } else {
            return Promise.reject(response);
          }
        })
        .catch((error) => {
          const err = {
            status: error.status,
            message: ""
          };

          if (error.status === 404) {
            err.message = "error.load";
          }
          return Promise.reject(err);
        });
      return response;
    },

    async apiAdd({ commit },crudData) {
      let apiRelativePath = crudData.path
      let saveData = crudData.saveData

      const response = await http.post(apiRelativePath, saveData)
        .then(res => {

          if ([200, 201, 204].includes(res.status)) {
            return res;
          } else {
            throw res;
          }
        })
        .catch(error => {

          const err = {
            status: error.status,
            errors: [],
            // Mensagens originais vindas do backend (errorMessage), na mesma ordem de errors.
            // Aditivo: nao altera o comportamento existente de quem so usa err.errors (codigos).
            errorMessages: []
          };

          // Verificar se é um objeto de erro com a estrutura { isSuccess, isFailure, errors }
          if (error.data && error.data.errors && Array.isArray(error.data.errors)) {
            error.data.errors.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
                err.errorMessages.push(item.errorMessage || null);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
                err.errorMessages.push(null);
              }
            });
          }
          // Verificar se é um objeto de erro com errorCode
          else if (error.data && error.data.errorCode) {
            err.errors.push(error.data.errorCode);
            err.errorMessages.push(error.data.errorMessage || null);
          }
          // Verificar se tem errors específico
          else if (error.data && error.data.errors) {

            Object.keys(error.data.errors).forEach(field => {
              const errorMessages = error.data.errors[field];

              errorMessages.forEach(msg => {
                err.errors.push(`${field}: ${msg}`);
                err.errorMessages.push(null);
              });

            });

          }
          // Verificar se data é um array
          else if (Array.isArray(error.data)) {

            error.data.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
                err.errorMessages.push(item.errorMessage || null);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
                err.errorMessages.push(null);
              }
            });

          }
          // Verificar formato de erro com Problem Details ({ type, detail, title, status })
          else if (error.data && error.data.type) {
            err.errors.push(error.data.type);
            err.errorMessages.push(error.data.detail || null);
          }

          return Promise.reject(err);
        });

      return response;
    },

    async apiUpdate({ commit }, { crudData }) {
      let apiRelativePath = crudData.path;
      let saveData = crudData.saveData;

      const response = await http.put(apiRelativePath, saveData)
        .then(res => {

          if ([200, 204].includes(res.status)) {
            return res;
          } else {
            throw res;
          }
        })
        .catch(error => {

          const err = {
            status: error.status,
            errors: [],
            // Mensagens originais vindas do backend (errorMessage), na mesma ordem de errors.
            // Aditivo: nao altera o comportamento existente de quem so usa err.errors (codigos).
            errorMessages: []
          };

          // Verificar se é um objeto de erro com a estrutura { isSuccess, isFailure, errors }
          if (error.data && error.data.errors && Array.isArray(error.data.errors)) {
            error.data.errors.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
                err.errorMessages.push(item.errorMessage || null);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
                err.errorMessages.push(null);
              }
            });
          }
          // Verificar se é um objeto de erro com errorCode
          else if (error.data && error.data.errorCode) {
            err.errors.push(error.data.errorCode);
            err.errorMessages.push(error.data.errorMessage || null);
          }
          // Verificar se tem errors específico
          else if (error.data && error.data.errors) {

            Object.keys(error.data.errors).forEach(field => {
              const errorMessages = error.data.errors[field];

              errorMessages.forEach(msg => {
                err.errors.push(`${field}: ${msg}`);
                err.errorMessages.push(null);
              });

            });

          }
          // Verificar se data é um array
          else if (Array.isArray(error.data)) {

            error.data.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
                err.errorMessages.push(item.errorMessage || null);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
                err.errorMessages.push(null);
              }
            });

          }
          // Verificar formato de erro com Problem Details ({ type, detail, title, status })
          else if (error.data && error.data.type) {
            err.errors.push(error.data.type);
            err.errorMessages.push(error.data.detail || null);
          }

          return Promise.reject(err);
        });

      return response;
    },

    async apiDelete({ commit }, { crudData }) {
      let apiRelativePath = crudData.path
     
      const response = await http.delete(apiRelativePath)
        .then(res => {

          if ([200, 204].includes(res.status)) {
            return res;
          } else {
            throw res;
          }
        })
        .catch((error) => {

          const err = {
            status: error.status,
            errors: [] 
          };

          // Verificar se é um objeto de erro com a estrutura { isSuccess, isFailure, errors }
          if (error.data && error.data.errors && Array.isArray(error.data.errors)) {
            error.data.errors.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
              }
            });
          }
          // Verificar se é um objeto de erro com errorCode
          else if (error.data && error.data.errorCode) {
            err.errors.push(error.data.errorCode);
          } 
          // Verificar se tem errors específico
          else if (error.data && error.data.errors) {
            
            Object.keys(error.data.errors).forEach(field => {
              const errorMessages = error.data.errors[field];

              errorMessages.forEach(msg => {
                err.errors.push(`${field}: ${msg}`);
              });
            });

          } 
          // Verificar se data é um array
          else if (Array.isArray(error.data)) {

            error.data.forEach(item => {
              // Se cada item tiver errorCode
              if (item.errorCode) {
                err.errors.push(item.errorCode);
              } else {
                // Caso contrário, adicionar o item diretamente
                err.errors.push(item);
              }
            });

          }
          // Verificar formato de erro com Problem Details ({ type, detail, title, status })
          else if (error.data && error.data.type) {
            err.errors.push(error.data.type);
          }
         
          return Promise.reject(err);
        });
      return response;
    },

  },
};
